import { ApplicationConfig } from '@angular/core';
import { NavigationError, provideRouter, withNavigationErrorHandler } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './core/interceptors/http.interceptor';
import localeFr from '@angular/common/locales/fr';
import { IMAGE_CONFIG, registerLocaleData } from '@angular/common';
import { requestInterceptor } from './core/interceptors/request.interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';

registerLocaleData(localeFr, 'fr');

function frPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Éléments par page :';
  intl.nextPageLabel = 'Page suivante';
  intl.previousPageLabel = 'Page précédente';
  intl.firstPageLabel = 'Première page';
  intl.lastPageLabel = 'Dernière page';
  intl.getRangeLabel = (page, pageSize, length) => {
    if (length === 0) return '0 sur 0';
    const start = page * pageSize + 1;
    const end = Math.min((page + 1) * pageSize, length);
    return `${start} – ${end} sur ${length}`;
  };
  return intl;
}

// Après un déploiement, les chunks de l'ancien build n'existent plus : le
// chargement lazy d'une route échoue ("Failed to fetch dynamically imported
// module"). On recharge alors la page sur l'URL cible pour récupérer le
// nouveau build. Le flag sessionStorage évite une boucle de rechargement si
// l'erreur persiste après reload.
function reloadOnStaleChunk(error: NavigationError): void {
  const message = String((error.error as Error)?.message ?? error.error ?? '');
  const isChunkLoadError =
    message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed');
  if (isChunkLoadError && sessionStorage.getItem('stale-chunk-reload') !== error.url) {
    sessionStorage.setItem('stale-chunk-reload', error.url);
    window.location.assign(error.url);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withNavigationErrorHandler(reloadOnStaleChunk)),
    provideHttpClient(withInterceptors([httpInterceptor, requestInterceptor])),
    provideAnimationsAsync(),
    { provide: MatPaginatorIntl, useFactory: frPaginatorIntl },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true
      }
    },
  ]
};
